import { css } from 'styled-components'

export default css`
  @media print {
    @page {
      size: A4 landscape;
    }
  }
`
